/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class LineItemDescriptionRegexQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("LineItemDescriptionRegexQueryOperator");
    }

    getFixupPrototypeFunction() { return LineItemDescriptionRegexQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<LineItemDescriptionRegexQueryOperator>): LineItemDescriptionRegexQueryOperator {
        let obj = Object.assign(new LineItemDescriptionRegexQueryOperator(), model);
        LineItemDescriptionRegexQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<LineItemDescriptionRegexQueryOperator>): LineItemDescriptionRegexQueryOperator {
        if (!model) return null;
        return LineItemDescriptionRegexQueryOperator.newInstance(<LineItemDescriptionRegexQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: LineItemDescriptionRegexQueryOperator) {
        if (!obj) return;

        models.LineItemDescriptionRegexQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: LineItemDescriptionRegexQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, LineItemDescriptionRegexQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.line_item_description) {
            models.Regex.fixupPrototype(this.line_item_description);
        }
    }

    /**
     * Line item description by regex match
     */
    line_item_description: models.Regex;

}
